import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const Ooscompo = () => {
	const navigate = useNavigate();
	const { ddmmyy } = useParams();
	// console.log(ddmmyy);

	const [jsxreturn, setjsx] = useState(false);
	const [oosdata, setoos] = useState(null);

	const now = new Date();

	const datematch = () => {
		const yy = now.getFullYear().toString().slice(2);
		let mm = (now.getMonth() + 1).toString();
		// mm.toString();
		if (mm.length === 1) {
			mm = "0" + mm;
		}

		let dd = now.getDate().toString();
		if (dd.length === 1) {
			dd = "0" + dd;
		}

		const check = `${dd}${mm}${yy}`;
		// console.log(check);

		if (ddmmyy === check) {
			return true;
		} else {
			return false;
		}
	};
	const calloos = () => {
		fetch("http://localhost:1111/oosjson")
			.then((response) => {
				// console.log("resp", response);
				return response.json();
			})
			.then((jsonData) => {
				// console.log("data", jsonData[0].head);
				setoos(jsonData);
				setjsx(true);
				// setloader(false);
				return jsonData;
			})
			// .then((jsonData) => console.log("-----------", jsonData))
			.catch((error) => {
				console.error("Error fetching data:", error, "OOS JSON ERR");
			});
	};
	// calloos();

	useEffect(() => {
		if (datematch()) {
			calloos();
		} else {
			navigate("/");
		}
	}, []);

	return (
		<>
			{jsxreturn ? (
				oosdata ? (
					<div className="oosbody">
						<h2>Out of search #Tags</h2>
						<div className="myhr"></div>
						<div className="oostable">
							<div className="oosrowhead oosrow">
								<div className="inflex">
									{/* <span></span> */}
									<p className="oosdate">Date</p>
								</div>
								<div className="inflex">
									{/* <span></span> */}
									<p className="oostags">Search String</p>
								</div>
								<div className="inflex">
									{/* <span></span> */}
									<div className="oosstring">
										<p className="oosdate">Tags</p>
									</div>
								</div>
							</div>
							{oosdata.map((oosobj, i) => {
								return (
									<div className="oosrow" key={i}>
										<div className="inflex">
											<span></span>
											<p className="oosdate">{oosobj?.searchdate}</p>
										</div>
										<div className="inflex">
											<span></span>
											<p className="oosstring">{oosobj.oos}</p>
										</div>
										<div className="inflex">
											<span></span>
											<div className="oostags">
												{Array.isArray(oosobj.stoken)
													? oosobj?.stoken?.map((nftoken, i) => {
															return <p key={i}>#{nftoken}</p>;
													  })
													: null}
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				) : null
			) : null}
		</>
	);
};

export default Ooscompo;
